import { render, staticRenderFns } from "./InternalVideoGrid.vue?vue&type=template&id=08e67485&"
import script from "./InternalVideoGrid.vue?vue&type=script&lang=js&"
export * from "./InternalVideoGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports